import i18n from 'modules/core/lib/i18n'

import { STATUS } from 'modules/goals/store/models/GoalConfig'

export const message = (status: string): string => {
  switch (status) {
    case STATUS.closed:
      return i18n.t('surveys.goals.show.banner.closed.message')

    case STATUS.active:
    default:
      return i18n.t('surveys.goals.show.banner.active.message')
  }
}

export const color = (status: string) => {
  switch (status) {
    case STATUS.closed:
      return 'error'

    case STATUS.active:
    default:
      return 'highlight'
  }
}
